/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Checkbox,
  Divider,
  Flex,
  Icon,
  Option,
  Select,
  Stack,
  Switch,
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import { DlpPolicyItem } from 'src/pages/Policy/utils/types';
import ActionNotification from './ActionNotification';
import RuleList from './RuleList';
export const KeywordExtractionRuleStatus = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  // get state from store
  const kfEnabled = policySelector((s) => s.tmKeywordfilters?.kfEnabled);
  // get action from store
  const setKfState = contextSelector((s) => s.setKfState);
  useWhyDidYouUpdate('KeywordExtractionRuleStatus', { kfEnabled });
  return (
    <Flex alignItems="center" pt="8px" pb="16px">
      <Switch
        mr="1x"
        checked={!!kfEnabled}
        value={kfEnabled}
        onChange={() => {
          setKfState({ kfEnabled: kfEnabled === 1 ? 0 : 1 });
        }}
      />
      <Text mr="8px" fontSize="18px" lineHeight="24px">
        {t('policy.keywordExtraction.checkbox.kfEnabled')}
      </Text>
    </Flex>
  );
};

const Rules = () => {
  console.log('render keyword extraction rules');
  return (
    <div>
      <Box ml="1px" mt="16px">
        <KeywordExtractionRuleStatus />
        <Divider mt="10px" mb="10px" />
        <RuleList />
      </Box>
    </div>
  );
};

const KeywordExtraction = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules />
          </TabPanel>
          <TabPanel>
            <ActionNotification
              advancedOptionShow={true}
              availableTokenShow={true}
              replaceFileNameShow={false}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(KeywordExtraction);
